import { IconProps } from './types';

export function Library({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 26 26" {...props}>
      <path
        fill="currentColor"
        d="M4.146 20.032a.787.787 0 0 1-.782-.781V7.792c0-4.593 1.396-5.99 5.99-5.99h7.291c4.594 0 5.99 1.397 5.99 5.99V18.21c0 .167 0 .323-.01.49a.795.795 0 0 1-.834.729.788.788 0 0 1-.729-.834c.01-.125.01-.26.01-.385V7.792c0-3.718-.697-4.427-4.427-4.427H9.354c-3.73 0-4.427.709-4.427 4.427v11.459a.787.787 0 0 1-.781.78Z"
      />
      <path
        fill="currentColor"
        d="M18.208 24.198H7.791a4.437 4.437 0 0 1-4.427-4.427v-.677a3.754 3.754 0 0 1 3.75-3.75h14.74c.427 0 .781.354.781.781v3.646a4.437 4.437 0 0 1-4.427 4.427ZM7.114 16.906c-1.208 0-2.187.98-2.187 2.188v.677a2.863 2.863 0 0 0 2.864 2.864h10.417a2.863 2.863 0 0 0 2.865-2.864v-2.865H7.114ZM17.166 8.572H8.833a.787.787 0 0 1-.781-.781c0-.427.354-.781.781-.781h8.333c.427 0 .782.354.782.781a.787.787 0 0 1-.782.781ZM14.041 12.219H8.833a.787.787 0 0 1-.781-.781c0-.428.354-.782.781-.782h5.208c.427 0 .782.354.782.781a.787.787 0 0 1-.782.782Z"
      />
    </svg>
  );
}
